import moment from 'moment';
import { createAction, handleActions } from 'redux-actions';
import { push } from 'connected-react-router';

import { setNewOfferTimes } from '../services/OfferService';
import { AnalyticsService } from '../services/AnalyticsService';
import { offerSteps } from '../components/Offers/Create/CreateOffer';

export const deleteFromState = createAction('DELETE_FROM_STATE');
export const moveForward = createAction('CREATE_OFFER_FORWARD', () => +1);
export const moveBack = createAction('CREATE_OFFER_BACK', () => -1);
export const cancelCreateOffer = createAction('CANCEL_CREATE_OFFER');

export const initiateOffer = createAction('INIT_OFFER', (data) => ({
  data,
}));

export const createFromPrevious = createAction(
  'CREATE_OFFER_FROM_PREVIOUS',
  (business: any, offer: any) => ({ business, offer })
);

export const addOfferDetails = createAction('ADD_OFFER_DETAILS', (data: any, change: number) => ({
  data,
  change,
}));

export function getPage(state: any, change: number) {

  const a = offerSteps[state.type];

  if (a === undefined) {

    return state.page + change;
  }

  if (change > 0) {

    const p = a.filter( function(n){
      return n !== null && n > state.page;
    });

    return p[0];
  }

  if (change < 0) {

    const p = a.filter( function(n){
      return n !== null && n < state.page;
    });

    return p[p.length - 1];
  }
}

export function cancelCreate() {
  localStorage.removeItem('currentOffer');
  return cancelCreateOffer();
}

export function finish() {
  return (dispatch) => {
    dispatch(push('/offers/submitted'));
    dispatch(deleteFromState());
  };
}

export function createNewOffer(data, type = '') {
  return initiateOffer({
    page: 1,
    categories: data.categories.map((item) => item.category),
    social_mentions: data.social_data.mentions,
    social_hashtags: data.social_data.hashtags,
    title: data.title,
    images: data.media.length
      ? [
          {
            file: data.media[0].media_id,
            preview: data.media[0].path,
          },
        ]
      : [],
    type: type !== '' ? type : '',
  });
}

function getOldOffer() {
  try {
    const data = JSON.parse(localStorage.getItem('currentOffer') || '');
    return data;
  } catch (error) {
    return {};
  }
}

const fixTime = (offer) => {
  if (offer.type === 'reservation_required' || offer.type === 'anytime') return {};
  return setNewOfferTimes(moment(offer.starts_at), moment(offer.ends_at), moment());
};

export default handleActions(
  {
    [createFromPrevious](state, { payload }) {
      const newOffer = { ...payload.offer };
      delete newOffer.id;
      delete newOffer.state;
      delete newOffer.is_fully_claimed;
      delete newOffer.taken_spots;
      delete newOffer.available_spots;
      delete newOffer.business_id;
      delete newOffer.description_formatted;
      delete newOffer.verification_status;
      delete newOffer.dress_code;
      delete newOffer.template_id;
      delete newOffer.template_key;
      delete newOffer.canceled_at;
      delete newOffer.attendees;
      const times = fixTime(newOffer);
      delete newOffer.starts_at;
      delete newOffer.ends_at;
      if (newOffer.media)
        newOffer.images = newOffer.media.map((item) => {
          return {
            file: item.media_id,
            preview: item.thumbnail,
          };
        });
      delete newOffer.media;

      AnalyticsService.track('Create from previous Offer', { name: newOffer.subtitle });
      return {
        ...newOffer,
        page: 1,
        ...times,
      };
    },
    [deleteFromState]() {
      return {};
    },
    [moveForward](state, { payload }) {
      const page = getPage(state, payload);
      AnalyticsService.track(`Create offer step ${page}`, {});
      return { ...state, page: page };
    },
    [moveBack](state, { payload }) {
      const page = getPage(state, payload);
      AnalyticsService.track(`Create offer step ${page}`, {});
      return { ...state, page: page };
    },
    [initiateOffer](state, { payload }) {
      return { ...payload.data };
    },
    [addOfferDetails](state, { payload }) {
      return {
        ...state,
        ...payload.data,
        page: getPage(state, payload.change)
      };
    },
    [cancelCreateOffer](state) {
      return {};
    },
  },
  { ...getOldOffer() }
);
